import React from 'react';

const Archive = ({color}) => { 
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 6.66699V17.5003H2.5V6.66699" stroke={color} strokeWidth="1.66667" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M19.1668 2.5H0.833496V6.66667H19.1668V2.5Z" stroke={color} strokeWidth="1.66667"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.3335 10H11.6668" stroke={color} strokeWidth="1.66667" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>

    )
}

export default Archive;